export default __webpack_public_path__ + "static/media/ico-question.d4b459b8.svg";